export default __webpack_public_path__ + "static/ios_service_banner-3a0d62468543b5d77ebad1a888071a25.svg";